// import { createRoot } from "react-dom/client";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/react";

import Routing from "./views/pages/index";
import { store } from "./redux/store";
import ErrorBoundary from "./views/components/Error/ErrorBoundary";
import SWRconfig from "./views/components/SWRconfig";
import ConfigTheme from "./views/containers/ConfigTheme";

Sentry.init({
  dsn: "https://da488cbd51794d46a8eedf462dd7b126@sentry.hamravesh.com/5354",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  enabled:false
  
  // document.location.host === "localhost:4000" ? false : true,
});

const App = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <HelmetProvider>
          <ConfigTheme>
            <BrowserRouter>
              <SWRconfig>
                <Routing />
              </SWRconfig>
            </BrowserRouter>
          </ConfigTheme>
        </HelmetProvider>
      </Provider>
    </ErrorBoundary>
  );
};

export default App;
